export const loginState = state => state.loginState
export const getAddressStore = state => state.address
export const getCustomIndex = state => state.customIndex
export const orderListObj = state => state.orderListObj
export const loginMess = state => state.loginMess
export const netWork = state => state.netWork